import { createQueryKeys } from "@lukemorales/query-key-factory";

import MasterApiBase from "./master-api.base";

export default class MembersApi extends MasterApiBase {
	/**
	 * @param {object} params
	 * @param {"csv" | "xlsx"} params.outputType
	 * @returns {Promise<any>}
	 */
	async #export(params) {
		return this.axios.get(`${this.endpoints.members}/export`, {
			params,
		});
	}

	#findAll = (params) => {
		return this.axios.get(this.endpoints.members, {
			params,
		});
	};

	#findAllSurveyAnswerHistories = ({ memberId, ...params }) => {
		return this.axios.get(
			`${this.endpoints.members}/${memberId}/survey-answer-histories`,
			{
				params,
			},
		);
	};

	#findAllLotteryDrawHistories = ({ memberId, ...params }) => {
		return this.axios.get(
			`${this.endpoints.members}/${memberId}/lottery-draw-histories`,
			{
				params,
			},
		);
	};

	#findAllVisits = ({ memberId, ...params }) => {
		return this.axios.get(`${this.endpoints.members}/visits/${memberId}`, {
			params,
		});
	};

	createVisit = ({ memberId, ...data }) => {
		return this.axios.post(`${this.endpoints.members}/visits/${memberId}`, data);
	};

	queryKeys = createQueryKeys("members", {
		list: (filters) => ({
			queryKey: [{ filters }],
			queryFn: () => this.#findAll(filters),
		}),
		listOfSurveyAnswerHistories: (filters) => ({
			queryKey: [{ filters }],
			queryFn: () => this.#findAllSurveyAnswerHistories(filters),
		}),
		listOfLotteryDrawHistories: (filters) => ({
			queryKey: [{ filters }],
			queryFn: () => this.#findAllLotteryDrawHistories(filters),
		}),
		listOfVisits: (filters) => ({
			queryKey: [{ filters }],
			queryFn: () => this.#findAllVisits(filters),
		}),
	});
}
